<pane-back-button backToRightPane="profile"></pane-back-button>
<div class="pane-content">
    <div class="d-flex w-100 justify-content-start align-items-center">
        <div class="profile-image">
            <profile-image></profile-image>
        </div>
        <div>
            <div class="profile-name">{{ user?.display_name }}</div>
            <div class="profile-status">{{ user?.tag_line }}</div>
        </div>
    </div>
    <hr>
    <ol class="list-group list-group-dark bg-dark text-light">
        <li class="list-group-item d-flex justify-content-between align-items-center">
            <div class="ms-2 me-auto">
                <div class="fw-bold">Profile Image</div>
            </div>
            <label class="upload-btn btn btn-outline" for="file-upload" >
                Change
                <fa-icon  class="ms-2" [icon]="faIcons.faImages"></fa-icon>
            </label>
            <input id="file-upload" type="file" (change)="onFileChange($event)" class="file-upload" />
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="mx-2 mb-2 w-100">
                <label for="nameInput" class="form-label fw-bold">Name</label>
                <textarea class="form-control" id="nameInput"
                          rows="1" placeholder="Doug Dimmadome" [(ngModel)]="displayName" ></textarea>
            </div>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-start">
            <div class="mx-2 mb-2 w-100">
                <label for="taglineInput" class="form-label fw-bold">Tag line</label>
                <textarea class="form-control" id="taglineInput"
                          rows="2" placeholder="Of the Dimmsdale dimmadome" [(ngModel)]="tagLine"></textarea>
            </div>
        </li>
    </ol>
    <div class="d-flex w-100 justify-content-center">
        <div class="btn-group" role="group" aria-label="Basic outlined example">
            <button type="button" class="btn btn-dark" (click)="cancel()">Cancel</button>
            <button type="button" class="btn btn-dark" (click)="save()">Save</button>
        </div>
    </div>
    <hr>
</div>
